import client from "../../../config/GraphQLApolloClient";
import {DELETE_SAP_SYSTEM_ENDPOINT, LIST_ALL_CONFIG, UPDATE_SAP_CONFIGURATION} from "../graphql/queries";
import {SapAdminConfig_SapSystemUpdate, SapAdminConfigVariables} from "../graphql/__generated__/SapAdminConfig";
import {
    DeleteSapSystemConfigQuery,
    DeleteSapSystemConfigQueryVariables
} from "../graphql/queries.generated";

export function updateSapAdminConfig(updateConfig:SapAdminConfig_SapSystemUpdate) {
    return client.query<SapAdminConfig_SapSystemUpdate,SapAdminConfigVariables>(
        {
            query: UPDATE_SAP_CONFIGURATION,
            variables: {sapConfig: updateConfig},
            fetchPolicy:'network-only'
        }).then(response => response.data);
}

export function deleteSapEndpoint(id: number): Promise<SapAdminConfig_SapSystemUpdate | null> {
    return client.query<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>(
        {
            query: DELETE_SAP_SYSTEM_ENDPOINT,
            variables: { id },
            fetchPolicy: 'network-only'
        }).then(response => {
            const result = response.data?.deleteSapSystemConfig;
            if (!result) return null;
            return {
                reportName: result.reportName,
                description: result.description,
                systemStatusList: result.systemStatusList.map(s => ({
                    id: s.id ?? null,
                    url: s.url,
                    path: s.path,
                    active: s.active,
                    filerResultsRule: s.filerResultsRule ?? null,
                    userName: '',
                    secretPlaceholder: '',
                    vaultProperty: '',
                    systemName: '',
                    systemNameFreeText: '',
                    description: '',
                    reachable: false,
                    placeHolderConfigured: false,
                    vaultPropertyFound: false,
                }))
            } as SapAdminConfig_SapSystemUpdate;
        });
}

export function getAllSapAdminConfig() {
    const result = client.query({
        query: LIST_ALL_CONFIG,
        fetchPolicy: "network-only"
    }).then(response =>  {
        const data = response.data.getSapSystemConfig;
        const updatableConfigList:SapAdminConfig_SapSystemUpdate[] = [];

        data.forEach(datum=> {
            const newItem: SapAdminConfig_SapSystemUpdate = {
                reportName: datum.reportName,
                description: datum.description,
                systemStatusList: datum.systemStatusList.map(systemItem => {
                        return {
                            id: systemItem.id,
                            path: systemItem.path,
                            url: systemItem.url,
                            active: systemItem.active,
                            reachable: systemItem.reachable,
                            userName: systemItem.userName,
                            secretPlaceholder: systemItem.secretPlaceholder,
                            vaultProperty: systemItem.vaultProperty,
                            systemName: systemItem.systemName,
                            systemNameFreeText: systemItem.systemNameFreeText,
                            filerResultsRule: systemItem.filerResultsRule,
                            description: systemItem.description,
                            placeHolderConfigured: systemItem.placeHolderConfigured,
                            vaultPropertyFound: systemItem.vaultPropertyFound
                        }
                    }
                )
            };

            updatableConfigList.push(newItem);
        });

        return updatableConfigList;
    });
    return result;
}
